(function () {
  angular.module('rightPaneModule')
    .controller('ClassroomAssignedLessonsController', [
      '$modal',
      '$scope',
      '$state',
      '$timeout',
      'assignedFocusApi',
      'assignMode',
      'cancelableResourceManager',
      'customer',
      'dblDateBucketService',
      'dblStandardsFactoryService',
      'moment',
      'progressApi',
      'standard',
      'studentApi',
      'teacherApi',
      ClassroomAssignedLessonsController]);

  function ClassroomAssignedLessonsController(
    $modal,
    $scope,
    $state,
    $timeout,
    assignedFocusApi,
    $assignMode,
    $cancelableResourceManager,
    $customer,
    dblDateBucketService,
    dblStandardsFactoryService,
    moment,
    dblProgressApi,
    $standard,
    $studentApi,
    $teacherApi
  ) {

    $scope.onAssignLessonClick = onAssignLessonClick;
    $scope.getTypes = getTypes;

    function onAssignLessonClick() {
      $assignMode.onClickAssignMode();
    }

    $scope.assignedLessonsData = null;
    $scope.assignmentHistoryLegendUrl = 'resources/right-pane/partials/assignment-history-legend.html';
    $scope.assignmentSupportArticleUrl = 'https://support.dreambox.com/s/article/AssignFocus-How-to-Create-Assignments-School-Teachers-and-Administrators';

    $scope.assignmentsAllowed = $assignMode.assignmentsAllowed();
    $scope.canceledCount = 0;
    $scope.page = 1;

    $scope.classroomHistoryExportUrl = "/r/districts/" + $state.params.districtId + "/classrooms/" + $state.params.classroomId + "/assignments?format=csv";

    $scope.typesModel = {};

    function getTypes(assignments) {
      // get the unique assignment types (like "SPOT" or "GOAL") and sort them descending
      var items = _.chain(assignments)
        .map(_.property('assignment_type'))
        .map(function (assignmentType) {
          return assignedFocusApi.getSupportedAssignmentType(assignmentType);
        })
        .uniq()
        .sortBy()
        .reverse()
        .value();

      return items;
    }

    var customerStandard = $customer.getAcademicStandard();
    var currentStandardName = customerStandard.academic_standard_name;

    function handlePagingEvent() {
      if ($scope.assignedLessonsData && !$scope.paging && !$scope.endOfPage) {
        $scope.paging = true;
        $scope.page++;

        updateAssignedLessonsData();
      }
    }

    function getClassroomStudents() {

      if(!$state.params.groupId){
        var promise = $studentApi.getStudentsForClassroom($state.params.classroomId, function (students) {
          $scope.studentIds = _.pluck(students, 'id');
          var pid = $cancelableResourceManager.add(promise);
          $cancelableResourceManager.remove(pid);
          updateAssignedLessonsData();
        });
      } else {
        updateAssignedLessonsData();
      }

    }

    function addStandards(lessonData, hideProficiency) {
      var focusType = lessonData.focus_type;
      var focusId = lessonData.focus_id;
      var toDate = moment(lessonData.end_date).format('YYYYMMDD');
      var studentId = lessonData.students[0].user_id;
      var districtId = $state.params.districtId;

      dblProgressApi.getGoalStandardProgressForStudentGivenStandardData(
        districtId,
        studentId,
        lessonData.focusData,
        toDate
      ).then(function (clusterData) {
        var clusters;

        if (focusType === 'DOMAIN') {
          clusters = clusterData.clusters;
        } else {
          clusters = [_.find(clusterData.clusters, {code: focusId.toString()})];
        }

        lessonData.standards = dblStandardsFactoryService.createStandardsForClusters(clusters);

        if (hideProficiency) {
          _.each(lessonData.standards.standards, function (standard) {
            standard.proficiencyStatus = undefined;
          });
        }
      });
    }

    // Group assignments by age of start date
    function getAssignmentDateBuckets(assignments, assignmentTypes) {
      var assignmentDateBuckets = {};
      var now = moment();

      _.each(assignments, function (assignment) {
        var assignmentType = assignedFocusApi.getSupportedAssignmentType(assignment.assignment_type);
        // filter by assignment type
        if (!assignmentTypes[assignmentType]) {
          return;
        }

        var dateBucket = dblDateBucketService.buildDateBucket(now, assignment.start_date);

        // if date bucket with same name already exists, use it
        var bucket = assignmentDateBuckets[dateBucket.name];
        if (!bucket) {
          bucket = dateBucket;

          bucket.assignments = [];

          assignmentDateBuckets[bucket.name] = bucket;
        }

        bucket.assignments.push(assignment);
      });

      return _.sortBy(_.values(assignmentDateBuckets), 'weeksAgo');
    }

    function updateAssignedLessonsData() {
      assignedFocusApi.getClassroomAssignedLessonsHistory($scope.page).then(function (data) {
        _.each(data.assignments, function (item) {
          // TODO: where is this used?
          _.extend(item, {start: new Date(item.start_date)});
        });

        $scope.pagingData = data.paging_response;
        $scope.assignedLessonsData = ($scope.assignedLessonsData || []).concat(data.assignments);
        $scope.endOfPage = ($scope.pagingData.next_page === null);

        // Dynamically add assignment type checkboxes based on which types are present in the latest page.  Checkboxes
        // are only shown if there are more than one of them.  Checkboxes default to checked.
        $scope.types = $scope.getTypes($scope.assignedLessonsData);
        _.each($scope.types, function (assignmentType) {
          var mappedAssignmentType = assignedFocusApi.getSupportedAssignmentType(assignmentType);
          if ($scope.typesModel[mappedAssignmentType] === undefined) {
            $scope.typesModel[mappedAssignmentType] = true;
          }
        });

        assignedFocusApi.appendFocusData(data.assignments).then(function (assignments) {
          // Add standards for the dropdown.  If there is more than one student
          // on the assignment the proficiencies will be hidden.
          _.each(assignments, function (assignment) {
            var focusType = assignment.focus_type;

            if (assignment.students.length > 0 && (focusType === 'DOMAIN' || focusType === 'CLUSTER')) {
              addStandards(assignment, assignment.students.length !== 1);
            }
          });

          // By default, the "latest" assignments are the ones that are currently active, unless
          // there are no active assignments. In that case, the latest ones are all of the assignments
          // that were created on the most recent date. Since this list contains assignments in multiple
          // states, we need to check to see if any of them are active. If not, we need to double back
          // and use the ones from the most recent and set them as the latest.
          var hasActive = false;
          var dataLength = $scope.assignedLessonsData.length;
          var lessonData;
          var i;

          for (i = 0; i < dataLength; i++) {
            lessonData = $scope.assignedLessonsData[i];
            lessonData.latest = lessonData.status === 'ACTIVE';

            if (lessonData.status === 'CANCELLED') {
              $scope.canceledCount++;
            }

            // Once we find an active lesson, we can disregard further logic.
            // Also, disregard any canceled assignments
            if (!hasActive && lessonData.status !== 'CANCELLED') {
              // If this lesson is active, stop tracking the most current lessons
              if (lessonData.latest) {
                hasActive = true;
                // currentDateItems = [];
                continue;
              }
            }
          }

          // If there are no active lessons, go back and make the most recent
          // ones the latest ones.
          if (!hasActive) {

            // If this isn't a paged set of data, get the newest start_date
            if ($scope.page === 1) {

              // get newest start_date
              var dates = _.map(data.assignments, function (item) {
                return moment(item.start_date);
              });
              var start = _.max(dates);

              // and all items that match the first item's date
              _.each(assignments, function (item, index) {
                var start_date = moment(new Date(item.start_date));
                if (start.startOf('day').isSame(start_date.startOf('day'))) {
                  // Set them as latest
                  item.latest = true;
                }
              });
            }
          }

          $scope.assignmentDateBuckets = getAssignmentDateBuckets($scope.assignedLessonsData, $scope.typesModel);

          $scope.paging = false;
          $scope.busy = false;
        });
      });
    }

    function systemAcademicStandardsList() {
      $teacherApi.getAcademicStandards(function (academic_standards) {
        $scope.academicStandardsList = angular.copy(_.indexBy(academic_standards, 'name'));
        $scope.currentStandard = $scope.academicStandardsList[currentStandardName];
      });
    }

    function initializeData(e, item) {
      $scope.busy = true;
      $scope.item = item;
      if (!$scope.item) {
        return;
      }

      $standard.resetParams();
      var context = JSON.parse(localStorage.getItem('context'));
      if(context && context.group){
        $state.params.groupId = context.group.groupId;
        $scope.classroomHistoryExportUrl = "/r/districts/" + $state.params.districtId + "/classrooms/" + context.group.groupId + "/assignments?format=csv";
      }
      getClassroomStudents();
      systemAcademicStandardsList();
    }

    function viewProgressClicked(e, assignment, student_id) {
      var modal = $modal.open({
        templateUrl: 'resources/core/partials/student-progress-modal.html',
        windowClass: 'fill-view-modal student-progress-modal',
        controller: 'StudentProgressModalController',
        backdrop: 'static',
        scope: $scope,
        resolve: {
          progressData: function () {
            var data = assignedFocusApi.createProgressDataFromAssignment(assignment, student_id);
            data.grade = $scope.item.grade;
            data.districtId = $state.params.districtId;

            return data;
          }
        }
      });
    }

    // watch using object equality to detect property value changes
    $scope.$watch('typesModel', function (newVal, oldVal) {
      // only update date buckets if property value toggled (not when property value is added)
      // to avoid potentially running bucketing multiple times when new pages are loaded
      var doUpdate = false;
      _.each(newVal, function (value, assignmentType) {
        if (oldVal[assignmentType] !== undefined && oldVal[assignmentType] !== value) {
          doUpdate = true;
        }
      });

      if (doUpdate) {
        $scope.assignmentDateBuckets = getAssignmentDateBuckets($scope.assignedLessonsData, newVal);
      }
    }, true);

    $scope.$on('itemReady', initializeData);

    function assignmentCanceled() {
      $scope.canceledCount++;

      $state.reload();
    }

    $scope.$on('assignmentCanceled', assignmentCanceled);
    $scope.$on('viewProgressClick', viewProgressClicked);
    $scope.$on('scrolledToBottom', handlePagingEvent);
    $scope.$on('mobileScrollBottom', handlePagingEvent);
  }
})();
